import { useInteractionStore } from '../../stores/interactionStore';
import { useViewStore } from '../../stores/viewStore';
import { benutzenTaste } from './benutzenTaste';
import './office.css';

const TEXTE = {
  hinsetzen: 'Hinsetzen',
  aufstehen: 'Aufstehen',
} as const;

/**
 * Hinweis am Stuhl — bewusst nicht in der Welt verankert wie der
 * Objekt-Hinweis: der Stuhl steht meist unter dem Fadenkreuz oder gleich
 * unter einem selbst, und dort haette eine Tafel ueber dem Sitz entweder im
 * Tisch gesteckt oder ausserhalb des Bildes geschwebt. Unter der Bildmitte
 * ist er in beiden Ansichten genau da, wo man hinsieht.
 */
export function SitzHinweis() {
  const aktion = useInteractionStore((s) => s.sitzAktion);
  // Solange ein Modal offen ist, gehoert die Taste der Oberflaeche — und der
  // Hinweis saesse mitten im Dialog
  const modalOffen = useInteractionStore((s) => s.openObject !== null);
  // Wie beim Objekt-Hinweis: die Ego-Ansicht benutzt mit der Leertaste,
  // weil dort E den Blick dreht; die Draufsicht behaelt ihr E.
  const mode = useViewStore((s) => s.mode);

  if (!aktion || modalOffen) return null;
  return (
    <div className="office__sit-hint" role="status">
      <strong>{benutzenTaste(mode)}</strong> {TEXTE[aktion]}
    </div>
  );
}
